var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 98,
    viewBox: "0 0 118 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 0.25V97.75H117.125V0.25H0.875ZM113.375 4V15.25H4.625V4H113.375ZM4.625 94V19H113.375V94H4.625Z",
    fill: "black",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 7.75H8.375V11.5H12.125V7.75Z",
    fill: "black",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 7.75H15.875V11.5H19.625V7.75Z",
    fill: "black",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 7.75H23.375V11.5H27.125V7.75Z",
    fill: "black",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 34C74.6075 34 67.9681 36.5725 62.84 41.1325C58.8106 30.1713 48.4044 22.75 36.5 22.75C20.9919 22.75 8.375 35.3669 8.375 50.875C8.375 66.3831 20.9919 79 36.5 79C43.3925 79 50.0319 76.4275 55.16 71.8675C59.1894 82.8288 69.5956 90.25 81.5 90.25C97.0081 90.25 109.625 77.6331 109.625 62.125C109.625 46.6169 97.0081 34 81.5 34ZM36.5 75.25C23.06 75.25 12.125 64.315 12.125 50.875C12.125 37.435 23.06 26.5 36.5 26.5C47.75 26.5 57.4756 34.1369 60.1494 45.0719C60.6312 47.0406 60.875 48.9925 60.875 50.875C60.875 56.86 58.6587 62.6294 54.6331 67.12C50.0019 72.2875 43.3906 75.25 36.5 75.25ZM81.5 86.5C70.5687 86.5 61.0775 79.2887 58.0944 68.8487C62.3131 63.79 64.625 57.4469 64.625 50.875C64.625 49.015 64.4206 47.1025 64.0194 45.1806C68.6075 40.4462 74.9262 37.75 81.5 37.75C94.94 37.75 105.875 48.685 105.875 62.125C105.875 75.565 94.94 86.5 81.5 86.5Z",
    fill: "black",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 32.125C30.2956 32.125 25.25 37.1706 25.25 43.375V54.625C25.25 60.8294 30.2956 65.875 36.5 65.875C37.9794 65.875 39.3912 65.5806 40.6869 65.0594C41.7519 66.7187 43.1394 68.1813 44.8344 69.31L46.9138 66.19C45.6781 65.365 44.66 64.3038 43.8762 63.0981C46.2444 61.0338 47.75 58.0056 47.75 54.625V43.375C47.75 37.1706 42.7044 32.125 36.5 32.125ZM44 54.625C44 56.3894 43.3625 57.9925 42.3388 59.275C42.2113 58.6094 42.125 57.9325 42.125 57.2406V56.5H38.375V57.2406C38.375 58.7594 38.6356 60.2331 39.0838 61.6394C38.2738 61.9375 37.4113 62.125 36.5 62.125C32.3637 62.125 29 58.7612 29 54.625V43.375C29 39.2387 32.3637 35.875 36.5 35.875C40.6363 35.875 44 39.2387 44 43.375V54.625Z",
    fill: "black",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7531 45.25H78.245L71.8006 65.875H68.375V69.625H70.6287L68.4594 76.5662L72.0387 77.6838L74.5588 69.625H88.4431L90.9613 77.6838L94.5406 76.5662L92.3713 69.625H94.625V65.875H91.1994L84.7531 45.25ZM75.7306 65.875L81.005 49H81.9969L87.2712 65.875H75.7306Z",
    fill: "black",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6cd786502011e6c7d01b9dc81f86bac1.svg";
export { ForwardRef as ReactComponent };